import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = {
  id: "Group_19",
  "data-name": "Group 19",
  transform: "translate(-706 -364)"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "10",
  stroke: "none"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "10",
  cy: "10",
  r: "8.75",
  fill: "none"
}, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["stroke"]

export interface Props {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CancelIcon',
  props: {
    color: { default: "#000" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", {
        id: "Ellipse_19",
        "data-name": "Ellipse 19",
        transform: "translate(706 364)",
        fill: "none",
        stroke: _ctx.color,
        "stroke-width": "2.5"
      }, _hoisted_6, 8, _hoisted_3),
      _createElementVNode("line", {
        id: "Line_13",
        "data-name": "Line 13",
        x2: "13",
        y2: "13",
        transform: "translate(709.5 367.5)",
        fill: "none",
        stroke: _ctx.color,
        "stroke-width": "2.5"
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})